const Content = () => {
  return (
    <div className='prose prose-gray max-w-none'>
      <div className='space-y-8'>
        {/* Initial explanation */}
        <div className='space-y-4'>
          <p className='text-t-primary leading-relaxed'>
            Normally, when you add your card to Apple Wallet or Google Wallet,
            the system will ask for a verification code sent via email or SMS.
          </p>
          <p className='text-t-primary leading-relaxed'>
            In some cases, the email or phone number shown on screen may not be
            yours, but don't worry — our system automatically forwards the code
            to your real email or phone.
          </p>
          <p className='text-t-primary leading-relaxed'>
            However, sometimes the system only shows the "call the bank" option
            to verify your card.
          </p>
          <p className='text-t-primary leading-relaxed font-medium'>
            When this happens, you need to follow the manual verification
            process in Manum.
          </p>
        </div>

        {/* Manual verification steps */}
        <div className='space-y-6'>
          <h2 className='font-semibold text-h4 text-t-primary'>
            Manual verification steps:
          </h2>

          <div className='space-y-4'>
            <div className='flex gap-4'>
              <span className='flex-shrink-0 w-8 h-8 bg-t-accent text-white rounded-full flex items-center justify-center font-medium text-sm'>
                1
              </span>
              <p className='text-t-primary leading-relaxed pt-1'>
                Go to your card screen in Manum.
              </p>
            </div>

            <div className='flex gap-4'>
              <span className='flex-shrink-0 w-8 h-8 bg-t-accent text-white rounded-full flex items-center justify-center font-medium text-sm'>
                2
              </span>
              <p className='text-t-primary leading-relaxed pt-1'>
                Click the "Verify Card" button.
              </p>
            </div>

            <div className='flex gap-4'>
              <span className='flex-shrink-0 w-8 h-8 bg-t-accent text-white rounded-full flex items-center justify-center font-medium text-sm'>
                3
              </span>
              <p className='text-t-primary leading-relaxed pt-1'>
                A form will open with your card number pre-filled.
              </p>
            </div>

            <div className='flex gap-4'>
              <span className='flex-shrink-0 w-8 h-8 bg-t-accent text-white rounded-full flex items-center justify-center font-medium text-sm'>
                4
              </span>
              <p className='text-t-primary leading-relaxed pt-1'>
                Upload a screenshot of your Wallet showing the card clearly.
              </p>
            </div>

            <div className='flex gap-4'>
              <span className='flex-shrink-0 w-8 h-8 bg-t-accent text-white rounded-full flex items-center justify-center font-medium text-sm'>
                5
              </span>
              <p className='text-t-primary leading-relaxed pt-1'>
                Do not remove the card from your phone until it's verified.
              </p>
            </div>
          </div>
        </div>

        {/* Timing and conditions */}
        <div className='space-y-6'>
          <h2 className='font-semibold text-h4 text-t-primary'>
            Timing and conditions:
          </h2>

          <div className='space-y-4'>
            <div className='bg-b-surface2 p-4 rounded-lg'>
              <p className='text-t-primary leading-relaxed'>
                If everything is correct, the bank will add it manually and it
                will appear verified in your Apple Pay or Google Pay.
              </p>
            </div>

            <div className='bg-b-surface2 p-4 rounded-lg'>
              <p className='text-t-primary leading-relaxed'>
                The maximum estimated time is <strong>24 business hours</strong>
                .
              </p>
            </div>

            <div className='bg-b-surface2 p-4 rounded-lg'>
              <p className='text-t-primary leading-relaxed'>
                The bank does not process verifications on weekends. Requests
                sent on Friday will be handled Sunday night to Monday morning.
              </p>
            </div>
          </div>
        </div>

        {/* Tips */}
        <div className='space-y-6'>
          <h2 className='font-semibold text-h4 text-t-primary'>Tips:</h2>

          <div className='space-y-4'>
            <div className='flex items-start gap-3'>
              <div className='w-2 h-2 bg-t-accent rounded-full mt-2 flex-shrink-0'></div>
              <p className='text-t-primary leading-relaxed'>
                Make sure the card is fully visible in the screenshot (no
                cropping).
              </p>
            </div>

            <div className='flex items-start gap-3'>
              <div className='w-2 h-2 bg-t-accent rounded-full mt-2 flex-shrink-0'></div>
              <p className='text-t-primary leading-relaxed'>
                Accepted formats: JPG or PNG, max 10 MB.
              </p>
            </div>

            <div className='flex items-start gap-3'>
              <div className='w-2 h-2 bg-t-accent rounded-full mt-2 flex-shrink-0'></div>
              <p className='text-t-primary leading-relaxed'>
                If you have questions, contact our support team.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
